'use strict';

(function () {

  'use strict';

  angular.module('msCore').service('surveySvc', surveySvc);

  surveySvc.$inject = ['httpSvc', '$sessionStorage', 'NotifyingSvc'];

  function surveySvc(httpSvc, $sessionStorage, NotifyingSvc) {
    return {
      setQ1: setQ1,
      getAllPrograms: getAllPrograms,
      setWellnessProgram: setWellnessProgram,
      getUserPrograms: getUserPrograms
    };

    /////////////////////////////////

    function setQ1(resp) {
      return httpSvc.post('/apiproxy/user/preferences', {
        'whatBringsYou': resp
      });
    }

    function setWellnessProgram(wpAnswers) {
      return httpSvc.post('/apiproxy/user/program', wpAnswers).then(function (authResponse) {
        if (!$sessionStorage.authRequirements && authResponse.requirements) {
          $sessionStorage.authRequirements = authResponse.requirements;
        } else if (authResponse.requirements && authResponse.requirements.length > 0) {
          $sessionStorage.authRequirements = _.unionWith($sessionStorage.authRequirements, authResponse.requirements, function (o, n) {
            return o.requirementType === n.requirementType;
          });
        }
        $sessionStorage.user = authResponse.response;
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.USER_UPDATED, {
          user: authResponse.response
        });
      });
    }

    /**
     * Fetch all programs for Condition
     * @returns {HttpPromise}
     */
    function getAllPrograms() {
      return httpSvc.get('/apiproxy/user/programs/condition');
    }

    function getUserPrograms() {
      return httpSvc.get('/apiproxy/user/programs');
    }
  }
})();